import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm, reset } from 'redux-form';
import { withStyles } from '@material-ui/core/styles';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { createStructuredSelector } from 'reselect';
import moment from 'moment';
import { selectUserAttributes } from '../../store/selectors';
import styles from './styles';
import LicenseExpiryModal from './LicenseExpiryModal';
import { updateUserProfile } from '../../store/actions/userProfile';
import { FORMS, USER_PROFILE_TYPES, USER_ROLE_TYPES } from '../../constants';

const propTypes = {
  classes: PropTypes.shape({}).isRequired,
  user: PropTypes.object,
  onUpdateUserProfile: PropTypes.func,
  change: PropTypes.func,
};

const LicenseExpiryModalContainer = ({
  user,
  onUpdateUserProfile,
  change,
  ...props
}) => {
  const [showModal, setShouldShowModal] = useState(false);
  useEffect(() => {
    if (
      user &&
      user['custom:roleType'] === USER_ROLE_TYPES.BUILDER.code &&
      !user['custom:buildingLicExp']
    ) {
      setShouldShowModal(true);
    }
  }, [user]);

  const submitFn = values => {
    // send in YYYY-MM-DD format to moment can parse when it reads it for profile card
    onUpdateUserProfile(
      localStorage.getItem('accessToken'),
      USER_PROFILE_TYPES.PERSONAL,
      {
        'custom:buildingLicExp': moment(
          values['custom:buildingLicExp'],
          'DD-MM-YYYY',
        ).format('YYYY-MM-DD'),
      },
      null,
    );
    setShouldShowModal(false);
  };

  return (
    <LicenseExpiryModal
      isOpen={showModal}
      user={user}
      submitFn={submitFn}
      change={change}
      {...props}
    />
  );
};

LicenseExpiryModalContainer.propTypes = propTypes;

const mapDispatchToProps = dispatch => ({
  onResetForm: form => dispatch(reset(form)),
  onUpdateUserProfile: (
    accessToken,
    profileType,
    userAttributes,
    businessAttributes,
  ) =>
    dispatch(
      updateUserProfile(
        accessToken,
        profileType,
        userAttributes,
        businessAttributes,
      ),
    ),
});

const mapStateToProps = createStructuredSelector({
  user: selectUserAttributes(),
});

export default reduxForm({ form: FORMS.BUILDER_LICENSE_EXPIRY })(
  withStyles(styles)(
    withMobileDialog()(
      connect(
        mapStateToProps,
        mapDispatchToProps,
      )(LicenseExpiryModalContainer),
    ),
  ),
);
